// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"PageNotFound-module--pageNotFound--vrogg","messageWrapper":"PageNotFound-module--messageWrapper--CZ_Au"};